module.exports = __webpack_public_path__ + "img/Logo_Horizontal_Light.18d96ec8.svg";